import React from 'react';
import MarketingShell from '../../components/MarketingShell';

const TEAM = [
  { name: 'Will Richman', role: 'Head of Client Earnings' },
  { name: 'Daniel Schloss', role: 'Head of Revenue' },
  { name: 'Haris Raheel', role: 'Growth Strategy' },
  { name: 'Ankit Mukherjee', role: 'Marketing Associate' },
  { name: 'Jenny Ryu', role: 'Marketing Associate' },
  { name: 'Ercan Erdogan', role: 'Team' },
  { name: 'Scott Spence', role: 'Advisor' },
];

export default function AboutPage() {
  return (
    <MarketingShell
      title="About"
      description="Help great people build great companies. We free teams from grant, savings, and operations busywork."
    >
      <div className="space-y-6 rounded-xl border border-gray-100 bg-white p-6">
        <p className="text-sm text-gray-600">
          Upgraded finds grants, tax credits, vendor savings, and AI upgrades for growing companies. We work
          on outcomes: if we do not deliver, you should not pay.
        </p>
        <div>
          <h2 className="text-base font-semibold text-gray-900">How we work</h2>
          <ul className="mt-3 space-y-2 text-sm text-gray-600">
            <li>Builders first — simplest system that creates the most value.</li>
            <li>Ubuntu — behave in ways that help the community.</li>
            <li>Sincere candor — say the hard thing carefully, and hear it.</li>
          </ul>
        </div>
        <div>
          <h2 className="text-base font-semibold text-gray-900">Team</h2>
          <ul className="mt-3 divide-y divide-gray-100">
            {TEAM.map((person) => (
              <li key={person.name} className="flex items-center justify-between py-3">
                <span className="text-sm font-medium text-gray-900">{person.name}</span>
                <span className="text-sm text-gray-500">{person.role}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </MarketingShell>
  );
}
